import { Guid } from "@syncfusion/ej2/pdf-export";

export class DocumentDataBO
{
    Id:string='00000000-0000-0000-0000-000000000000'
    isDocumentVerified:string;
    PermissionDelete:boolean;
    validTill:string;
}
export class DocumentBO {
    id:string='00000000-0000-0000-0000-000000000000'
    clientId: string="";
    documentNameLid:Guid;
    documentName: string;
    returnDocument: string;
    containerName: string;
    documentType: string;
    documentTitle: string;
    attachedDate: string | null;
    filepath: string;
    fileString:string;
    isRemoved: boolean | null;
    removedBy: string;
    removedDate: string | null;
    attachments: any;
    employeeId:string='00000000-0000-0000-0000-000000000000'
    isMNChoiceAssessment: boolean=false;
    validTill:string;
  }
  export class LovBO {
    id: string='00000000-0000-0000-0000-000000000000';
    lovCode: string;
    lovName: string;
    lovValue: string;
    listId: number;
    orderby: number = 0;
    agencyId: number | null;
    isRequired: boolean;
  }

  export class GetDocumentBO {
    clientId: string="";
    employeeId: string="";
    orderColumn: string = "documentName";
    orderType: string= "asc";
    pageitem: number = 10;
    currentpageno: number = 1;
    locationId:number=0;
    field: string = "documentName";
    value: string = "";
    matchCase: boolean = false;
    operator: string = "startswith";
    agencyID: number;
    type:string="string";
    validStatus :string='active';
    checklistLid :string ='00000000-0000-0000-0000-000000000000';

}

export class UpdateDocumentBO {
  id: string='00000000-0000-0000-0000-000000000000';
  documentTitle: string;
  isMNChoiceAssessment:boolean=false;
  validTill:string;
  documentNameLid :string ='00000000-0000-0000-0000-000000000000';
}